import { Skeleton } from '@mui/material'
import { LoadingPresentationalTable, PresentationalTable, Rule } from 'components/core-v2'

import { formatCurrencyFull } from '../../../../utilities/currency'
import classes from './fee-breakdown-table.module.scss'
import { FeeCategory, FormattedFeeData } from './utils'

const ROW_OPTIONS = [{ width: '60%' }, { width: '40%', align: 'right' }]

interface Props {
  data: FormattedFeeData
}
export const FeeBreakdownTable = ({ data }: Props) => (
  <>
    <div>
      {Object.values(data.split).map((split: FeeCategory) => (
        <PresentationalTable
          key={split.name}
          headerRow={[split.name, formatCurrencyFull(split.fees, data.currency)]}
          rowOptions={ROW_OPTIONS}
          rows={Object.values(split.split).map(split => [
            split.name,
            formatCurrencyFull(split.fees, data.currency)
          ])}
        />
      ))}
    </div>
    <Rule className="my-8" />
    <div className={classes.total}>
      <strong>Total</strong>
      <strong>{formatCurrencyFull(data.fees, data.currency)}</strong>
    </div>
  </>
)

export const FeeBreakdownLoadingTable = () => (
  <div>
    <LoadingPresentationalTable rowCount={3} rowOptions={ROW_OPTIONS} />
    <LoadingPresentationalTable rowCount={1} rowOptions={ROW_OPTIONS} />
    <LoadingPresentationalTable rowCount={1} rowOptions={ROW_OPTIONS} />
    <Rule className="my-8" />
    <div className={classes.total}>
      <strong>Total</strong>
      <Skeleton height="16px" width="100px" />
    </div>
  </div>
)
